/* Stripped down version of: https://github.com/glennreyes/react-countup */

import React, { useRef, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import Count from './helpers/countup'

const CountUp = ({ end, start, duration, children, style }) => {
  const isInitializedRef = useRef(false)
  const countUpRef = useRef(null)

  const createInstance = () => {
    if (!countUpRef.current)
      return console.error(
        `Couldn't find attached element to hook the CountUp instance into! Try to attach "countUpRef" from the render prop to a an HTMLElement, eg. <span ref={countUpRef} />.`
      )

    return new Count(countUpRef.current, start, end, null, duration)
  }

  const restart = useCallback(() => countUpRef?.current?.start(), [countUpRef.current])

  const update = useCallback((newEnd) => countUpRef?.current?.update(newEnd), [countUpRef.current])

  useEffect(() => {
    countUpRef.current = createInstance()
    isInitializedRef.current = true
  }, [])

  useEffect(() => {
    if (isInitializedRef.current) update(end)
  }, [end, update])

  useEffect(() => {
    if (isInitializedRef.current) restart()
  }, [restart, start, duration])

  if (typeof children === 'function') {
    return children({
      countUpRef,
      start: countUpRef?.current?.start,
      reset: countUpRef?.current?.reset
    })
  }

  return <span ref={countUpRef} style={style} />
}

CountUp.propTypes = {
  duration: PropTypes.number,
  end: PropTypes.number.isRequired,
  start: PropTypes.number
}

CountUp.defaultProps = {
  start: 0,
  duration: 2
}

export default CountUp
